import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';
import Criteria from './Criteria';

export class LearningOutcome extends BaseModel {
  static get entity() {
    return 'learning-outcomes';
  }

  static get fk() {
    return 'learning_outcome_id';
  }

  static fields() {
    return {
      id: this.uid(),
      title: this.attr(null),
      description: this.attr(null),
      pass_criterion: this.attr(null),
      not_yet_criterion: this.attr(null),
      is_ultimate: this.boolean(false),
      ultimate_learning_outcome_id: this.attr(null),
      ultimate_learning_outcome: this.belongsTo(LearningOutcome, 'ultimate_learning_outcome_id'),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      sub_learning_outcome_ids: this.attr([]),
      sub_learning_outcomes: this.hasManyBy(
        LearningOutcome,
        'sub_learning_outcome_ids',
        'ultimate_learning_outcome_id'
      ),
      criterion_ids: this.attr([]),
      criteria: this.hasManyBy(Criteria, 'criterion_ids', 'learning_outcome_id'),
      properties: this.string('{}'),
      created_at: this.attr(null),
      updated_At: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetchById(id, params = {}) {
        return this.get(`/learning-outcomes/${id}`, {
          params
        });
      },

      fetchPostAlignment(id, params = {}) {
        return this.get(`/learning-outcomes/${id}/post-alignments`, {
          params
        });
      },

      createLearningOutcome(body) {
        return this.post(`/learning-outcomes`, body);
      },

      updateLearningOutcome(id, body) {
        return this.put(`/learning-outcomes/${id}`, body);
      },

      deleteLearningOutcome(id) {
        return this.delete(`/learning-outcomes/${id}`, {
          delete: id
        });
      },

      createUltimateLearningOutcome(learning_unit, { title, description = null } = {}) {
        return this.post(`/learning-outcomes/ultimate-learning-outcome`, {
          title,
          description,
          learning_unit
        });
      },

      updateUltimateLearningOutcome(id, { title, description = null } = {}) {
        return this.put(`/learning-outcomes/ultimate-learning-outcome/${id}`, {
          title,
          description
        });
      },

      createSubLearningOutcome({ title, ultimate_learning_outcome, description = null } = {}) {
        return this.post(`/learning-outcomes/sub-learning-outcome`, {
          title,
          description,
          ultimate_learning_outcome
        });
      },

      updateSubLearningOutcome(id, { title, ultimate_learning_outcome, description = null } = {}) {
        return this.put(`/learning-outcomes/sub-learning-outcome/${id}`, {
          title,
          description,
          ultimate_learning_outcome
        });
      },

      deleteSubLearningOutcome(id) {
        return this.delete(`/learning-outcomes/sub-learning-outcome/${id}`, {
          delete: id
        });
      },

      updateProperties(id, properties = {}) {
        return this.put(`/learning-outcomes/${id}/properties`, {
          ...properties
        });
      }
    }
  };
}

export default LearningOutcome;
